import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi } from '../../api/admin';
import AdminHeader from '../../components/adminHeader';
import AdminFooter from '../../components/adminFooter';
import { useAppDispatch } from '../../state/hooks';
import { loginSuccess } from '../../state/auth';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleLogin = async () => {
    try {
      const response = await adminApi.login({ username, password });
      localStorage.setItem('admin_token', response.data.accessToken);
      dispatch(loginSuccess(response.data.name));
      navigate('/admin');
    } catch (error) {
      console.error('Admin login failed', error);
    }
  };

  return (
    <div className="w-full h-full flex flex-col bg-gray-900 font-mono text-white">
      <AdminHeader />
      <div
        style={{
          backgroundImage: "url(assets/img/rpg-bg.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className="flex-grow flex flex-col items-center justify-center w-full relative pt-6 px-4"
      >
        <div className="w-full max-w-md bg-gray-800 bg-opacity-80 p-6 md:p-10 rounded-lg border-2 border-gray-700 shadow-lg transform transition-all duration-300 hover:scale-105">
          <h1 className="text-4xl font-bold mb-8 text-center text-yellow-400 drop-shadow-lg">Admin Portal</h1>
          <div className="space-y-6">
            <input
              type="text"
              placeholder="Enter Username..."
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full p-3 bg-gray-700 border border-gray-600 rounded-md text-lg placeholder-gray-400 focus:outline-none focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500 transition-all duration-200"
            />
            <input
              type="password"
              placeholder="Enter Password..."
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-3 bg-gray-700 border border-gray-600 rounded-md text-lg placeholder-gray-400 focus:outline-none focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500 transition-all duration-200"
            />
            <button onClick={handleLogin} className="w-full py-3 bg-yellow-600 hover:bg-yellow-700 text-white font-bold text-xl rounded-md shadow-lg transform transition-all duration-200 hover:scale-105 active:scale-95 focus:outline-none focus:ring-2 focus://ring-yellow-500 focus:ring-opacity-75 border-b-4 border-yellow-800">
              Access Realm
            </button>
          </div>
        </div>
      </div>
      <AdminFooter />
    </div>
  );
};

export default AdminLogin;
